"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var description_1 = require("./utils/description");
/**
 * Returns a function that checks whether a value is equal to one of allowed values
 * Function compares values using === operator
 *
 * @example
 * const isAllowedToAccess = is.oneOf('ROLE_ADMIN', 'ROLE_USER');
 * // same as
 * // const isAllowedToAccess = is.in(['ROLE_ADMIN', 'ROLE_USER']);
 *
 * isAllowedToAccess('ROLE_ADMIN'); // true
 * isAllowedToAccess('ROLE_ANONYMOUS'); // false
 *
 * @throws {Error} if 0 or 1 allowed value provided
 */
function isOneOf() {
    var allowedValues = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        allowedValues[_i] = arguments[_i];
    }
    if (allowedValues.length < 2) {
        throw new Error('At least 2 allowed values are required');
    }
    return description_1.setDescription(function isOneOfPredicate(value) {
        return allowedValues.indexOf(value) !== -1;
    }, 'one of values: ' + allowedValues.join(', '));
}
exports.default = isOneOf;
